/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import { motion } from "framer-motion";
import { terms_of_use } from "../assets/svg";

const ServiceDetailItem = ({ title, description }) => (
  <motion.li
    initial={{ opacity: 0, y: 10 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    viewport={{ once: true }}
    className="text-gray-700 leading-8 mb-4"
  >
    {title}
    {description && (
      <p className="text-sm text-gray-500 font-normal">{description}</p>
    )}
  </motion.li>
);

const TermsOfUseDetails = () => {
  const termsOfUseDetails = [
    {
      title:
        "This web site contains material including text, photographs and other images and sound, which is protected by copyright and/or other intellectual property rights. All copyright and other intellectual property rights in this material are either owned by SeQuenX B.V. or have been licensed to it by the owner(s) of those rights so that it can use this material as part of this web site.",
    },
    {
      title:
        'This web site also contains trade marks & logos, including the "SeQuenX" animated logo / trade marks and "Software Quality Engineering Excellence" tag line. All trade marks, & logos included on this web site belong to SeQuenX B.V. or have been licensed to it by the owner(s) of those trade marks for use on this web site.',
    },
  ];

  const youMayDetails = [
    {
      title: "access any part of the web site;",
    },
    {
      title:
        "print off one copy of any or all of the pages for your own personal reference.",
    },
  ];

  const youMayNotDetails = [
    {
      title:
        "copy (whether by printing off onto paper, storing on disk, downloading or in any other way), distribute (including distributing copies), broadcast, alter or tamper with in any way or otherwise use any material contained in the web site. These restrictions apply in relation to all or part of the material on the web site;",
    },
    {
      title:
        "remove any copyright, trade mark or other intellectual property notices contained in the original material from any material copied or printed off from the web site; without our express written consent.",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-gray-800 mb-4 ">
            Terms of Use
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <div className="flex flex-col md:flex-row items-center gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="w-full md:w-1/2"
          >
            <img
              src={terms_of_use}
              alt="Terms of Use"
              className="w-full max-w-lg mx-auto rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="w-full md:w-1/2 space-y-6"
          >
            <div className="prose prose-lg">
              <p className="text-gray-700 leading-relaxed">
                Welcome to the SeQuenX.com website. This web site is owned and
                operated by SeQuenX B.V., a company registered in The
                Netherlands, whose registered office is at Office 6J5 |
                Vitruviusstraat 138, 2314 CW, Leiden, The Netherlands. Visitors
                to this web site are bound by the following terms and
                conditions, please read these carefully before you continue.
              </p>
              <h2 className="text-2xl font-bold text-gray-800 my-6">
                Terms of Use
              </h2>
              <ul className="list-disc list-inside">
                {termsOfUseDetails.map((detail, index) => (
                  <ServiceDetailItem
                    key={index}
                    title={detail.title}
                    description={detail.description}
                  />
                ))}
              </ul>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-20"
        >
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">You may</h2>
              <ul className="list-disc list-inside">
                {youMayDetails.map((detail, index) => (
                  <ServiceDetailItem key={index} title={detail.title} />
                ))}
              </ul>

              <h2 className="text-2xl font-bold text-gray-800 my-6">
                You may not
              </h2>
              <ul className="list-disc list-inside">
                {youMayNotDetails.map((detail, index) => (
                  <ServiceDetailItem key={index} title={detail.title} />
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TermsOfUseDetails;
